export default function() {
  const widgetName = 'cardWidgetAmpCircles';
  const widgetOpts = cardWidgetAmpCirclesOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW'
    },
    cardWidgetLoaded: function(data, owl, hasData) {
      const w = $(`#${widgetName}`);
      const wItem = w.find('.card-widget-item');
      const circleCount = data.items.length;


      w.addClass(`circles-${circleCount}x`);
      wItem.prepend('<div class="circle-rings"></div>');

      wItem.each(function(i) {
        $(this).addClass(`item-${i+1}`)
      });

      w.show();

    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: false,
    link: ['all'], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 4,
    moreButton: {
      visible: false,
      text: 'Buy Tickets'
    },
    scriptPath:  widgetOpts.scriptPath,
    showDescription: false,
    slideshow: false, // for documentation on Owl Slider: https://owlcarousel2.github.io/OwlCarousel2/docs/started-welcome.html
    slideshowOptions: {
      items: 1,
      loop: true,
      margin: 10,
      navText: ['Prev','Next'],
      nav: true
    },
    textOverImage: true
  });

}